import React from "react"
import { Row, Col, Icon, Button, Card, Typography } from "antd"
import { useIntl } from "gatsby-plugin-intl"
import premiumWebsitesStyles from "./solutions.module.css"

const { Title } = Typography

export default ({ openContactForm }) => {
  const intl = useIntl()

  return (
    <Row
      type="flex"
      justify="space-around"
      align="middle"
      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
    >
      <Col xs={24} sm={20} lg={12} xl={12}>
        <div
          style={{
            width: "100%",
            minHeight: "300px",
            boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            margin: "10px 0",
            padding: 20,
            textAlign: "center",
          }}
          className={premiumWebsitesStyles.premiumWebsitesCard}
        >
          <Title
            level={2}
            style={{
              fontFamily: "Poppins",
              fontSize: "40px",
              textAlign: "center",
              color: "#fff",
            }}
          >
            {intl.formatMessage({ id: "sofwareAsAService" })}
          </Title>
          <p style={{ color: "#fff" }}>
            {intl.formatMessage({ id: "saasDescription" })}
          </p>
          <Title
            level={2}
            style={{
              fontFamily: "Poppins",
              fontSize: "30px",
              textAlign: "center",
              color: "#fff",
            }}
          >
            {intl.formatMessage({ id: "saasTitleCTA" })}
          </Title>
          <Button
            onClick={() =>
              openContactForm(intl.formatMessage({ id: "sofwareAsAService" }))
            }
            type="primary"
          >
            {intl.formatMessage({ id: "saasCTA" })}
          </Button>
        </div>
      </Col>
      <Col xs={24} sm={20} lg={12} xl={12}>
        <div
          style={{
            width: "100%",
            minHeight: "400px",
            backgroundColor: "#fff",
            // boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <Card
            style={{
              width: "100%",
              borderRadius: 10,
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
              // margin: 10,
            }}
          >
            <Row
              type="flex"
              justify="space-around"
              align="middle"
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            >
              <Col xs={24} sm={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0",
                  }}
                >
                  <Icon
                    type="cloud"
                    style={{ width: "100%", fontSize: 60, marginBottom: 10 }}
                  />
                </div>
              </Col>
              <Col xs={24} sm={20}>
                <Title
                  level={3}
                  style={{
                    fontFamily: "Poppins",
                  }}
                >
                  {intl.formatMessage({ id: "inTheCloud" })}
                </Title>
                <p>
                  {intl.formatMessage({
                    id: "inTheCloudDescription",
                  })}
                </p>
              </Col>
            </Row>
          </Card>
          <Row type="flex" justify="center">
            <Col>
              <Icon
                type="plus-circle"
                style={{ marginTop: 20, marginBottom: 20 }}
              />
            </Col>
          </Row>
          <Card
            style={{
              width: "100%",
              borderRadius: 10,
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
              // margin: 10,
            }}
          >
            <Row
              type="flex"
              justify="space-around"
              align="middle"
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            >
              <Col xs={24} sm={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0",
                  }}
                >
                  <Icon
                    type="control"
                    style={{ width: "100%", fontSize: 60, marginBottom: 10 }}
                  />
                </div>
              </Col>
              <Col xs={24} sm={20}>
                <Title
                  level={3}
                  style={{
                    fontFamily: "Poppins",
                  }}
                >
                  {intl.formatMessage({ id: "payAsYouGo" })}
                </Title>
                <p>
                  {intl.formatMessage({
                    id: "payAsYouGoDescription",
                  })}
                </p>
              </Col>
            </Row>
          </Card>
        </div>
      </Col>
    </Row>
  )
}
